//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
	name: 'Aktuality',

	data () {
		return {
			pages: 1,
		};
	},

	async fetch () {
		try {
			const response = await this.$axios.get('/blogs/blog?page=' + this.$route.query.page);
			this.pages = response.data.payload.paginator.pagesTotal;
			await this.$store.dispatch('blogs/fetchBlogsBlogs', response.data.payload.items);
		}
		catch (e) {
			this.$nuxt.error({
				statusCode: 404,
				message: 'Unable to fetch aktuality posts at this time. Please try again.',
			});
		}
	},

	head () {
		return {
			title: this.$config.webTitle[this.$i18n.locale] + ' - Aktuality',
			meta: [
				{
					name: 'description',
					content: this.$config.webDescription[this.$i18n.locale],
				},
				{
					property: 'og:title',
					content: this.$config.webTitle[this.$i18n.locale],
				},
				{
					property: 'og:description',
					content: this.$config.webDescription[this.$i18n.locale],
				},
			],
		};
	},

	computed: mapState({
		blogs: (state) => state.blogs.blogs,
	}),

	watch: {
		'$route.query': '$fetch',
	},

	fetchOnServer: true,

	methods: {
		scrollToTop () {
			window.scrollTo(0, 0);
		},

		prevPage () {
			if (parseInt(this.$route.query.page) !== 1) {
				this.$router.push('/aktuality?page=' + (parseInt(this.$route.query.page) - 1));
				this.scrollToTop();
			}
		},

		nextPage () {
			if (parseInt(this.$route.query.page) !== this.pages) {
				this.$router.push('/aktuality?page=' + (parseInt(this.$route.query.page) + 1));
				this.scrollToTop();
			}
		},
	},
};
